import { render, staticRenderFns } from "./SchemaSetting.vue?vue&type=template&id=243e3614&scoped=true"
import script from "./SchemaSetting.vue?vue&type=script&lang=ts"
export * from "./SchemaSetting.vue?vue&type=script&lang=ts"
import style0 from "./SchemaSetting.vue?vue&type=style&index=0&id=243e3614&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243e3614",
  null
  
)

export default component.exports